module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "IS-EB-5P-4.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('h1', {
    attrs: {
      "id": "toc_marker-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "Anchor-284"
    }
  }, [_vm._v("Dedication")])]), _c('a', {
    attrs: {
      "id": "Anchor-284"
    }
  }, [_c('p', [_vm._v("This one is for Britton Edwards.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _c('p', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Apple has a core set of talents, and those talents are: We do, I think, very good hardware design; we do very good industrial design; and we write very good system and application software. And we’re really good at packaging that all together into a product. We’re the only people left in the computer industry that do that.")])]), _vm._v(" "), _c('p', [_vm._v("—Steve Jobs, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rolling Stone")]), _vm._v(", December 25, 2003")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-284"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-284"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05ceac3d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IS-EB5P-4.vue
// module id = 69
// module chunks = 0